//TODO refactor for ES6

function ReflowAssetLibrary($scope, FolderService, $filter, $element, $location) {  
    
    this.$scope = $scope;
    this.FolderService = FolderService;
    this.$filter = $filter;
    this.$element = $element;
    
    this.filterExpression = "*";
    
    var dividerTop = localStorage.getItem("reflow_divider_top");
    if("undefined" !== typeof dividerTop && dividerTop !== null) {
        this.dividerTop = parseFloat(dividerTop);
    }
    else {
        this.dividerTop = 200;
    }
    
}

ReflowAssetLibrary.prototype.setDroppableUpload = function() {
    var assetLibrary = $(".asset-library-main");
    var self = this;

    //Need to apply a border around asset-library when a file is dragged into the area
    assetLibrary.on('dragenter', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).css('border', '1px solid green');
    });
    assetLibrary.on('dragleave', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).css('border', '0');
    });
    assetLibrary.on('dragover', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).css('border', '1px solid green');
    });
    assetLibrary.on('drop', function (e) {
        e.preventDefault();
        $(this).css('border', '0');
        var files = e.originalEvent.dataTransfer.files;
        self.$scope.showUploadPanel(files);
    });
    $(document).on('drop', function (e) {
        e.stopPropagation();
        e.preventDefault();
    });

};

ReflowAssetLibrary.prototype.folderTreeUpdated = function(updated) {
    if("undefined" !== typeof updated) {
        this.$scope.folders = [];
        this.parseFolderTree(updated, this.$scope.folders, false);
        this.$scope.isLoading = false;
    }
};

ReflowAssetLibrary.prototype.searchOrFilterContents = function(patt) {  
    var self = this;
    self.filterExpression = (patt === self.$scope.searchExpression)
        ? self.filterExpression
        : patt;
    self.currentFolderChanged(self.currentFolderId);
};

ReflowAssetLibrary.prototype.parseFolderTree = function(foldersIn, foldersOut, expanded) {

    var self = this;
    
    if("undefined" === typeof foldersIn) {
        return;
    }

    if(foldersIn === Array) {
        $.each(foldersIn, function(ix, folder){
            
            var extraClasses = "";
            if(folder.name.toLowerCase == " recycle bin") {
                extraClasses = "recyclebin";
            }
            
            var newfolder = {
                key: folder.id,
                title: folder.name,
                folder: true,
                lazy: true,
                data: folder,
                expanded: expanded,
                children: [{
                    key: folder.id,
                    title: folder.name,
                    folder: true,
                    //TODO loop througxh children and check if lazy or not?
                    lazy: true,
                    data: folder,
                    expanded: expanded,
                    children: null}
                ],
                extraClasses: extraClasses
            };

            foldersOut.push(newfolder);
            // self.parseFolderTree(folder.subFolders, newfolder.children, false);
            
        });
        if(foldersOut.length > 1) {
            foldersOut.sort(function(i1, i2){ return i1.title.toLowerCase().localeCompare(i2.title.toLowerCase()); });  
        }
    }
    else {
        foldersOut.push({
            key: foldersIn.id,
            title: foldersIn.name,
            folder: true,
            data: foldersIn,
            lazy: true
            // lazy: foldersIn.lazy
        });
    }

};

ReflowAssetLibrary.prototype.currentFolderChanged = function(folderId, selectAsset, reloadNode) {
    
    var self = this;
    
    if("undefined" !== typeof folderId && folderId !== null) {

        var node = self.$scope.tree.getNodeByKey(folderId);

        if("undefined" !== typeof node && node !== null && node.lazy && reloadNode ) {
            var parent = node.parent;
            node.resetLazy();
            node.setExpanded(true);
        }
  
        self.currentFolderId = folderId;
        localStorage.setItem("reflow_library_current_folder", folderId);
        this.FolderService.searchOrFilterFolder(folderId, self.filterExpression, self.$scope.searchExpression)
            .then((data) => {

                var assetToSelect = null;
                self.$scope.contents = [];
                $.each(data.data.assets, function(ix, asset) {

                    var libraryAsset = {
                        id: asset.id,
                        canDoTranscode: (/^video/.test(asset.contentType)),
                        canRename: true,
                        canDelete: true,
                        name: asset.name,
                        parentId: asset.parentId,
                        contentType: asset.contentType,
                        src: asset.src,
                        urn: asset.urn,
                        date: moment(asset.createdDate).format("LLL")
                    };  

                    if(asset.contentType.toLowerCase().indexOf("video") > -1) {
                        libraryAsset.gsPath = asset.src.split("/")[0] + "/" + asset.urn;
                    }

                    self.$scope.contents.push(libraryAsset);

                    if(asset.contentType == "x-reflow/adunit") {
                        libraryAsset.canvases = asset.canvases;
                    }

                    if("undefined" !== typeof selectAsset && asset.id == selectAsset.id) {
                        assetToSelect = libraryAsset;
                    }
                });

                self.$scope.subfolders = [];
                $.each(data.data.folders, function(ix, folder) { 
                    self.$scope.subfolders.push({
                        id: folder.id,
                        canRename: (folder.name !== " Recycle bin" && folder.canWrite),
                        canDelete: (folder.name !== " Recycle bin" && folder.canWrite),
                        name: folder.name,
                        parentId: folder.parentId,
                        urn: folder.urn,
                        // hasChildren: true,
                        hasChildren: folder.hasChildren,
                        contentType: "x-reflow/folder",
                        date: moment(folder.createdDate).format("LLL")
                    });
                });

                self.sort();
                
                if(assetToSelect != null) {
                    self.$scope.currentAsset = assetToSelect;
                }
                else {
                    self.$scope.currentAsset = null;
                }
                            
                self.setPanePositions();

            }, (response) => {
                this.$scope.error = true;
                console.error(response);
            });
    }
};

ReflowAssetLibrary.prototype.expandNodeParents = function(parentNodes) {

    var self = this;

    if(parentNodes.length > 0) {
        var n = parentNodes.pop();
        if(self.$scope.tree.getNodeByKey(n.id) !== null) {
            var node = self.$scope.tree.getNodeByKey(n.id);

            //Will throw if an error occurs, need to check for this with the .failure callback
            node.setExpanded(true).done(function(){
                if(parentNodes.length === 0) {
                    node.setActive(true);
                }
                self.expandNodeParents(parentNodes);
            });
        }
    }

};

ReflowAssetLibrary.prototype.openParentFolder = function() {
    
    var self = this;

    var node = self.$scope.tree.getNodeByKey(self.$scope.currentFolder.parentId);

    node.setExpanded(true).done(() =>{
        node.setActive(true);
        self.$scope.currentFolder = node.data;
        self.$scope.tree.activateKey(self.$scope.currentFolder.id);
    });
};

ReflowAssetLibrary.prototype.selectNode = function(node) {
    
    localStorage.setItem("reflow_library_selected_node", node.key);
    
    this.$scope.selectedNode = node;
    this.$scope.currentFolder = node.data;
    
    this.$scope.user.currentFolderId = node.key;
};

ReflowAssetLibrary.prototype.selectSubFolder = function(folder) {
    
    localStorage.setItem("reflow_library_selected_node", folder.id);
    this.$scope.currentAsset = folder;
    this.$scope.lowerPaneExpanded = false;
    this.$scope.canExpandLowerPane = false;
    this.setPanePositions();
    
};

ReflowAssetLibrary.prototype.selectAsset = function(asset) {
    asset.fullSrc = this.cdnPath(asset.src);
    this.$scope.currentAsset = asset;
    if(asset.contentType === "x-reflow/user" || asset.contentType === "x-reflow/group") {
        this.$scope.lowerPaneExpanded = false;
        this.$scope.canExpandLowerPane = false;                         
    }
    else {
        this.$scope.canExpandLowerPane = !this.$scope.isRecycleBin;
    }
    this.setPanePositions();
};

ReflowAssetLibrary.prototype.cdnPath = function(src) {
    if(/^http/.test(src)) {
        return src;
    }
    else if(/^\/\//.test(src)) {
        return src;
    }
    else {
        return "https://cdn.ctnsnet.com/ase/fetch/uas/" + src;
    }
    
};

ReflowAssetLibrary.prototype.expandContractLowerPane = function() {
    
    this.$scope.lowerPaneExpanded = !this.$scope.lowerPaneExpanded;
    this.setPanePositions();
    
    localStorage.setItem("reflow_pane_expanded", this.$scope.lowerPaneExpanded);
        
};

ReflowAssetLibrary.prototype.updateDividerPosition = function(dividerTop) {
    this.dividerTop = dividerTop;
    localStorage.setItem("reflow_divider_top", dividerTop);
};

ReflowAssetLibrary.prototype.setPanePositions = function(dividerTop) {
    
    var overall = $(".asset-library-panes").height();
    if(overall == 0) {
        overall = $(window).height() - 110;
    }
    
    if("undefined" == typeof dividerTop) {
        var top = this.dividerTop;
    }
    else {
        var top = dividerTop;
    }
    
    //With lazy loading at this point we won't know the number of subfolders unless the user has visited the folder already so just check the hasChildren flag
    if (this.$scope.currentAsset == null || "undefined" === typeof this.$scope.currentFolder || this.$scope.contents.length === 0 && !this.$scope.currentFolder.hasChildren) {//&& this.$scope.currentFolder.subFolders.length === 0) {
        this.$scope.topPaneHeight = overall - 30;
        $(".asset-library-top").css("height", this.$scope.topPaneHeight);
        $(".asset-library-bottom").css("display", "none");
        $(".asset-library-divider").css("display", "none");
    }
    else {
        
        if(!this.$scope.lowerPaneExpanded) {
            
            $(".asset-library-bottom").removeClass("default");
            $(".asset-library-bottom").addClass("contracted");
            
            this.$scope.topPaneHeight = overall - 100;                   
            $(".asset-library-top").css("height", this.$scope.topPaneHeight);
            $(".asset-library-bottom").css("height", 98);
            
            $(".asset-library-divider").css("display", "block");
            $(".asset-library-bottom").css("display", "block");
            
        }
        else {
            
            
            $(".asset-library-bottom").removeClass("default");
            $(".asset-library-bottom").removeClass("contracted");
            
            $(".asset-library-bottom").css("display", "block");
            $(".asset-library-divider").css("display", "block");
            
            
            this.$scope.topPaneHeight = top - 50;                    
            this.$scope.bottomPaneHeight = overall - this.$scope.topPaneHeight - 5;
            
            $(".asset-library-top").css("height", this.$scope.topPaneHeight + "px");
            $(".asset-library-bottom").css("height", this.$scope.bottomPaneHeight + "px");
            $(".asset-library-top").scrollTop(top);
        }
        
    }
    
};

ReflowAssetLibrary.prototype.onFolderCreated = function(newitem) {

    if("undefined" !== typeof newitem.parentId && newitem.parentId == this.$scope.user.currentFolderId) {
        newitem.date = moment(newitem.createdDate).format("LLL");
        this.$scope.subfolders.push(newitem);
    }

    this.sort();
    
    var parent = this.$scope.tree.getNodeByKey(newitem.parentId);
    if("undefined" != typeof parent && parent != null) {

        parent.resetLazy();
        // parent.setExpanded(true);
        parent.setExpanded(true).done(() =>{
            parent.setActive(true);
            this.$scope.tree.activateKey(newitem._id);
        });
}
    
};

ReflowAssetLibrary.prototype.onFolderDeleted = function(deleted) {
    
    if(deleted.parentId === this.$scope.user.currentFolderId) {
        var idx = _.indexOf(this.$scope.subfolders, deleted);
        if(idx >= 0) {
            this.$scope.subfolders.splice(idx, 1);
        }
    }
    
};

ReflowAssetLibrary.prototype.onAssetCreated = function(newitem) {
    this.currentFolderChanged(this.$scope.user.currentFolderId, newitem, true); 
};

ReflowAssetLibrary.prototype.onAssetUpdated = function(updated) {
    this.currentFolderChanged(this.$scope.user.currentFolderId, updated, true);
};

ReflowAssetLibrary.prototype.onAssetDeleted = function(olditem) {   
    this.currentFolderChanged(this.$scope.user.currentFolderId, self.currentAsset, true);   
};

ReflowAssetLibrary.prototype.setupDropTarget = function(node) {

    var self = this;
    
    $(">span", $(node.li)).droppable({
        accept: function(src) {
            var asset = $(src).data("asset");
            if($(src).hasClass("asset_library_draggable") && node.data.id != asset.id && node.data.id != asset.folderId) {
                return true;
            }
            else {
                return false;
            }
        },
        drop: function(ev, ui) {
            $("#" + node.li.id).removeClass("drag-over");
            var asset = ui.draggable.data("asset");
            if(asset.contentType == "x-reflow/folder") {
                self.$scope.$emit("moveFolder", {target: node.data, folder: asset});
            }
            else {
                self.$scope.$emit("moveAsset", {target: node.data, asset: asset});
            }
        },
        over: function(ev, ui) {
            $("#" + node.li.id).addClass("drag-over");
        },
        out: function(ev, ui) {
            $("#" + node.li.id).removeClass("drag-over");
        }
    });

};

ReflowAssetLibrary.prototype.sort = function() {
    
    var self = this;
    
    function getVal(x) {
        switch(self.$scope.curSortKey) {
        case "name":
            return x.name.toUpperCase();
            break;
        case "type":
            return self.$filter('labelForContentType')(x.contentType).toUpperCase();
            break;
        case "created":
            return moment(x.createdDate).unix();
            break;
        default:
            return 0;
            break;
        }
    }
    
    function sortFunc(a, b) {
        if(getVal(a) > getVal(b)) {
            return self.$scope.curSortAsc ? 1 : -1;
        }
        else if(getVal(a) < getVal(b)) {
            return self.$scope.curSortAsc ? -1 : 1;
        }
        else {
            return 0;
        }
    }
    
    this.$scope.subfolders.sort(sortFunc);  
    this.$scope.contents.sort(sortFunc);
    
};





angular.module("cpm").directive("assetLibrary", ['AssetService', "FolderService", "ApiService", "CONTENT_TYPE", "$timeout", "$filter", "$uibModal", "Notification", "$rootScope", "EVENTS", "SERVICE_LOCATIONS", "$location", function(AssetService, FolderService, ApiService, CONTENT_TYPE, $timeout, $filter, $uibModal, Notification, $rootScope, EVENTS, SERVICE_LOCATIONS, $location){
    return {
        restrict: "E",
        templateUrl: "asset-library/asset-library.html",
        scope: {},
        link: function($scope, $element, $attributes) {

            $scope.folders = [];
            $scope.contents = [];
            $scope.currentAsset = null;
            $scope.filterExpression = "*";
            $scope.searchExpression = "";
            $scope.selectedNode = null;
            $scope.lowerPaneExpanded = true;
            $scope.canExpandLowerPane = true;
            $scope.isLoading = true;
            $scope.lightsOn = false;
            $scope.curSortKey = "name";
            $scope.curSortAsc = "true";
            $scope.isRecycleBin = false;
            $scope.currentFilter = "";
            this.$uibModal = $uibModal;
            this.$scope = $scope;
            this.CONTENT_TYPE = CONTENT_TYPE;
            this.Notification = Notification;
            this.EVENTS = EVENTS;
            this.SERVICE_LOCATIONS = SERVICE_LOCATIONS;
            $scope.user = $rootScope.currentUser;
        
            //Need to return whether has read/write but will do for now as the backend won't allow you to anyway.
            $scope.canCreateFolders = true;
            $scope.canUploadFiles = true;

            this.FolderService = FolderService;
            
            var delegate = new ReflowAssetLibrary($scope, FolderService, $filter);
            
            delegate.setPanePositions();
            delegate.setDroppableUpload();
            
            $scope.expandContractLowerPane = () => {               
                delegate.expandContractLowerPane();
            };

            $scope.setUpTree = () => {
                let queryParams = $location.search();
                let currentFolderId = localStorage.getItem("reflow_library_current_folder");

                if(queryParams.hasOwnProperty("folderId") && !isNaN(queryParams.folderId)) {
                    currentFolderId = queryParams.folderId;
                }

                if(!currentFolderId) {
                    currentFolderId = $scope.user.rootFolder;
                }

                FolderService.getFolder($scope.user.rootFolder)
                    .then((response) => {
                        $scope.folders = response.data;

                        FolderService.getFolderWithDescendants(currentFolderId)
                            .then((response) => {
                                $scope.currentFolder = response.data[response.data.length-1];
                                $scope.user.currentFolderId = $scope.currentFolder.id;
                                delegate.folderTreeUpdated($scope.folders);
                                $(".tree-view-inner", $element).fancytree("option", "source", $scope.folders);
                                let nodes = response.data;
                                nodes.reverse();
                                delegate.expandNodeParents(nodes);

                            }, (response) => {
                                $scope.error = true;
                                console.error(response);
                            });

                    }, (response) => {
                        $scope.error = true;
                        console.error(response);
                    });

            };

            if(!!$scope.user) {
                $scope.setUpTree();
            }
            
            $(".tree-view-inner", $element).fancytree({
                selectMode: 1,
                extensions: ["edit"],
                generateIds: true,
                source: $scope.folders,
                init: (ev, data) => {
                    $scope.tree = data.tree;
                },
                activate: (event, data) => {              
                    delegate.selectNode(data.node);
                    $timeout(() => {
                        $scope.$apply();
                        data.node.makeVisible({scrollIntoView: false}).done(function() {
                            data.node.scrollIntoView();
                        });
                    });
                },
                lazyLoad: function(event, data) {
                    var deferredResult = jQuery.Deferred();
                    var result = [];
                    setTimeout(function() { 
                        var get = $.ajax({
                            url: "/api/folder/" + data.node.key + "/subfolders",
                            type: "GET"
                        }); 
                        get.done((p) => {

                            $.each(p, (i, folder) => {
                                var extraClasses = "";
                                if(folder.name == " Recycle bin") {
                                    extraClasses = "recyclebin";
                                }
                                folder.key = folder.id;
                                folder.folder = true;
                                folder.title = folder.name;
                                folder.lazy = true;
                                folder.lazy = folder.hasChildren;
                                folder.extraClasses = extraClasses;
                            });

                            $scope.user.currentFolderId = data.node.key;
                            p.sort(function(i1, i2){ return i1.title.toLowerCase().localeCompare(i2.title.toLowerCase()); }); 
                            deferredResult.resolve(p);
                        });
                    }.bind(this), 0);
                    data.result = deferredResult;
                },
                renderNode: (event, data) => {
                    delegate.setupDropTarget(data.node);
                }
            });
            
            $(".asset-library-divider").draggable({
                revert: false, 
                appendTo: "body", 
                containment: ".asset-library-panes", 
                helper: "clone",
                ghost: false,
                axis: "y",
                opacity: 0.5, 
                zIndex: 4998,
                start: (ev, args) => {
                    $scope.lowerPaneExpanded = true;
                    $(".asset-library-bottom").removeClass("contracted");
                    $scope.$apply();
                },
                drag: (ev, args) => {
                    delegate.setPanePositions(args.offset.top - 110);
                    $scope.$apply();
                },
                stop: (ev, args) => {
                    delegate.updateDividerPosition(args.offset.top - 110);
                    $scope.$apply();
                }
            });
            
            $(window).resize((ev) => {
                delegate.setPanePositions();
            });
            
            
            $scope.selectSubFolder = (folder) => {
                delegate.selectSubFolder(folder);
            };
                        
            $scope.selectAsset = function(asset) {
                delegate.selectAsset(asset);
            };          
            
            $scope.openCurrentAsset = (asset) => {

                if("undefined" !== typeof asset) {
                    delegate.selectAsset(asset);
                }

                if($scope.currentAsset.contentType == "x-reflow/folder") {
                    //TODO - Move to delegate, don't re-use
                    var node = $scope.tree.getNodeByKey($scope.currentAsset.parentId);
                    node.setExpanded(true).done(() =>{
                        node.setActive(true);
                        $scope.tree.activateKey($scope.currentAsset.id);
                    });
                }
                else {
                    try {
                        let el = document.createElement('textarea');
                        el.value = this.SERVICE_LOCATIONS.CDN_URL + asset.src;
                        el.setAttribute('readonly', '');
                        el.style.position = 'absolute';
                        el.style.left = '-9999px';
                        document.body.appendChild(el);
                        el.select();
                        document.execCommand('copy');
                        document.body.removeChild(el);
                        $scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Copied asset path to clipboard."})
                    }
                    catch(e) {
                        $scope.$emit(EVENTS.SHOW_NOTIFICATION, {'message': "Could not copy asset path to clipboard at this, your browser may not support this action. Please copy the path from the asset library instead.", messageType: "error"});
                        console.error(e);
                    }
                }
            };
            
            $scope.copyCurrentAsset = () => {
                $scope.$emit("copyAsset", $scope.currentAsset);
            };
            
            $scope.deleteCurrentAsset = () => {

                var modalInstance = this.$uibModal.open({
                    animation: this.$scope.animationsEnabled,
                    templateUrl: 'delete-confirm.html',
                    controller: 'DeleteConfirmationCtrl'
                });

                modalInstance.result.then(() => {
                    let contentType = this.$scope.currentAsset.contentType  === "x-reflow/folder" ? CONTENT_TYPE.FOLDER : CONTENT_TYPE.ASSET;

                    ApiService.delete(contentType, $scope.currentAsset.id)
                        .then((response) => {
                            delegate.onAssetUpdated();
                        }, (response) => {
                            console.error(response);
                            this.$scope.error = true;
                        });
                },() => {
                    // NOOP
                });

            };                      
                        
            $scope.transcodeCurrentAsset = () => {

                AssetService.transcode($scope.currentAsset.id)
                    .then((response) => {
                        this.Notification.success("Transcode request sent");
                    }, (response) => {
                        if (response.status === 404) {
                            this.$scope.noResults = true;
                        } else {
                            console.error(response);
                            this.$scope.error = true;
                        }
                        this.$scope.error = true;
                        this.Notification.success("There was an issue sending the transcode request.");
                    });

            };
            
            $scope.filterContents = (patt, title) => {
                $scope.currentFilter = title;
                delegate.searchOrFilterContents(patt);
            };
            
            $scope.searchContents = () => {
                delegate.searchOrFilterContents($scope.searchExpression);
            };
            
            $scope.showUploadPanel = (files) => {
                
                $scope.modalInstance = $uibModal.open({
                    controller: "FileUploadCtrl",
                    templateUrl: "file-uploader/file-upload.html",
                    resolve: { 
                        folderId: () => { return $scope.user.currentFolderId; },
                        currentDirectoryListing: () => { return $scope.contents; },
                        files: () => { return !!files ? files : [];  }
                    }
                });

            };
            
            $scope.createFolder = () => {

                let modalInstance = this.$uibModal.open({
                    animation: true,
                    templateUrl: 'asset-library/create-folder.html',
                    controller: 'AddItemCtrl',
                    resolve: {
                    },
                    scope: $scope
                });

                modalInstance.result.then((folder) => {

                    let parentId = this.$scope.user.currentFolderId;

                    var data = {
                        name: folder.name,
                        folderId: parentId,
                        parentId: parentId,
                    };

                    ApiService.create(this.CONTENT_TYPE.FOLDER, data)
                        .then((response) => {
                            this.$scope.$root.$broadcast("folder_created", response.data);
                        }, (response) => {
                            if (response.status === 404) {
                                this.$scope.noResults = true;
                            } else {
                                console.error(response);
                                this.$scope.error = true;
                            }
                            this.$scope.error = true;
                        });
                }, () => {
                    
                });
            };

            $scope.renameCurrentAsset = () => {

                let message = "Rename " + $scope.currentAsset.name + "...";

                var modalInstance = this.$uibModal.open({
                    animation: this.$scope.animationsEnabled,
                    templateUrl: 'components/update-item.html',
                    controller: 'UpdateItemCtrl',
                    resolve: {
                        title: () => { return message; }, 
                        item: () => { return { name: $scope.currentAsset.name }; }
                    },  
                    scope :this.$scope
                });

                modalInstance.result.then((asset) => {
                    this.$scope.currentAsset.name = asset.name;
                    let contentType = this.$scope.currentAsset.contentType  === "x-reflow/folder" ? this.CONTENT_TYPE.FOLDER : CONTENT_TYPE.ASSET;

                    ApiService.update(contentType, this.$scope.currentAsset)
                        .then((response) => {
                            delegate.onAssetUpdated(response.data);
                        }, (response) => {
                            if (response.status === 404) {
                                this.$scope.noResults = true;
                            } else {
                                console.error(response);
                                this.$scope.error = true;
                            }
                            this.$scope.error = true;
                        });
                }, () => {
                    
                });
            };
            
            $scope.sort = (sortKey) => {
                $scope.curSortKey = sortKey;
                delegate.sort();
            };
            
            $scope.toggleSortOrder = function() {
                $scope.curSortAsc = !$scope.curSortAsc;
                delegate.sort();
            };
                        
            $scope.parentFolder = function() {
                delegate.openParentFolder();
            };
            
            $scope.$watch("currentAsset", function(updated) {
                delegate.setPanePositions();
            });

            $scope.$watch("user.currentFolderId", function(updated) {
                $location.search("folderId", updated);
                delegate.currentFolderChanged(updated);             
            });

            $scope.$watch("user.currentFolder", function(updated) {
                if("undefined" !== typeof updated && updated != null) {
                    $scope.isRecycleBin = ($scope.currentFolder.name == " Recycle bin");            
                    $scope.lowerPaneExpanded = !$scope.isRecycleBin;
                    $scope.canExpandLowerPane = !$scope.isRecycleBin;
                }
            });
            
            $scope.$on("folder_created", function(ev, args) {
                delegate.onFolderCreated(args);
            });
            
            $scope.$on("folder_deleted", function(ev, args) {
                delegate.onFolderDeleted(args);
            });
            
            $scope.$on("asset_created", function(ev, args) {
                delegate.onAssetCreated(args);
            });

            $scope.$watch('user', (newVal, oldVal) => {
                if(!(!!oldVal) && !!newVal) {
                    $scope.user = newVal;
                    $scope.setUpTree();
                }

            });

            $scope.$watch("user.currentFolder", (updated) => {
                if(!!updated) {
                    $scope.isRecycleBin = ($scope.currentFolder.name == " Recycle bin");            
                    $scope.lowerPaneExpanded = !$scope.isRecycleBin;
                    $scope.canExpandLowerPane = !$scope.isRecycleBin;
                }
            });
                        
        }
    };
}]);
